/**
 * Calculates progress percentage. Returns 0 if totalRows is 0.
 */
export function calcProgress(processedRows: number, totalRows: number): number {
  if (totalRows === 0) return 0;
  return Math.round((processedRows / totalRows) * 100);
}

/**
 * Returns true only for 'queued' or 'processing' statuses.
 * Used to determine whether polling should continue.
 */
export function isPollingEnabled(status: string): boolean {
  return status === 'queued' || status === 'processing';
}
